import { delay } from '@pjn/utils/delay';
/**
 * Extiende el prototype de Vue con propiedades utiles.
 *
 * Se pueden usar en cualquier componente usando `this`.
 *
 * @param Vue
 */
export function extendVue(Vue) {
    Vue.prototype.$baseUrl = process.env.BASE_URL;
    Vue.prototype.$dev = (process.env.NODE_ENV !== 'production');
    Object.defineProperty(Vue.prototype, '$mobile', {
        get: function get() { return this.$vuetify.breakpoint.xsOnly; }
    });
    Object.defineProperty(Vue.prototype, '$mq', {
        get: function get() { return (normal, mobile) => this.$mobile ? mobile : normal; }
    });
    Vue.prototype.$delayNextTick = function (ms, callback) {
        if (callback) {
            delay(ms).then(() => this.$nextTick(callback));
        }
        else {
            return delay(ms).then(() => this.$nextTick());
        }
    };
    Vue.prototype.$focusNextTick = function (ref, delayMs) {
        this.$delayNextTick(delayMs || 0, () => this.$refs[ref].focus());
    };
}
//# sourceMappingURL=extensions.js.map